import { Navigate, useParams } from "react-router-dom";

export type DocumentRouteTarget = {
  id: string;
  direction?: string | null;
  status?: string | null;
};

export function getNewDocumentPath() {
  return "/documents/new";
}

export function getDocumentDetailPath(id: string) {
  return `/documents/${id}`;
}

export function getDocumentEditPath(id: string) {
  return `/documents/${id}/edit`;
}

export function getDocumentOpenPath(document: DocumentRouteTarget) {
  return document.direction === "OUTBOUND" && document.status === "DRAFT"
    ? getDocumentEditPath(document.id)
    : getDocumentDetailPath(document.id);
}

export function DocumentDetailRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? getDocumentDetailPath(id) : "/documents"} replace />;
}

export function DocumentEditRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? getDocumentEditPath(id) : getNewDocumentPath()} replace />;
}
